module.exports = __webpack_public_path__ + "img/app.5cd3bf6f.png";